/**
 * @description The controller invoked when viewing project details
 * @param {library} $uibModal Unknown
 * @param {library} Lightbox Unknown
 * @param {service} AlertMessages Unknown
 * @param {service} Session The user session service.
 * @param {constant} RESPONSE_MESSAGES Response messages constant.
 * @param {angular} $rootScope The Angular $rootScope service
 * @param {service} Shop The Shop service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function ProjectController(
  $uibModal,
  Lightbox,
  AlertMessages,
  Session,
  RESPONSE_MESSAGES,
  $rootScope,
  Shop,
  MessageTemplates
) {
  let vm = this;
  vm.$onInit = function() {
    vm.session = Session;

    // Public methods
    vm.openPhotoLightbox = openPhotoLightbox;
    vm.openProjectModal = openProjectModal;
    vm.addCompletedphoto = addCompletedphoto;

    // Defaults
    vm.selectedOptions = {};
    vm.archiveConfirm = false;
  };

  // Open a specific modal after loading the project and appointment
  vm.open === 'add-completed-photo' &&
  vm.currentAppointment.current_status === 70 ? addCompletedphoto() : null;

/**
 * @description Reference and coverup images modal
 * @param {array} array The array of photos used to go to the next or previous
 * photo in the collection when inside the lightbox
 * @param {number} photo The photo, by index, to load in the modal
 */
  function openPhotoLightbox(array, photo) {
    Lightbox.openModal(array, photo);
  }

  /**
   * @description Open the project update modal for editing
   */
  function openProjectModal() {
    let modalInstance = $uibModal.open({
      template: require('./update/project-update.template.html'),
      animation: true,
      controller: 'ProjectUpdateController',
      controllerAs: '$ctrl',
      size: 'lg',
      resolve: {
        project: function() {
          return vm.project;
        },
        appointment: function() {
          return vm.currentAppointment;
        }
      }
    });
    modalInstance.result.then(function(returnData) {
      // When the project is saved, the modal close function is called, which
      // Delivers back the returnData. We set the project and appointment in
      // this scope to the updated versions
      if (returnData.formattedProject) {
        vm.project = returnData.formattedProject;
        vm.onProjectChange({project: returnData.formattedProject});
        // Update appointment activity
        let conversationId;
        let appointmentId;
        $rootScope.$broadcast('merge-activity', conversationId,
        appointmentId, returnData.formattedProject.id);
      }

      // Update the appointment if it changed
      if (returnData.updatedAppointment) {
        Shop.get(returnData.updatedAppointment.shop).then(function(response) {
          returnData.updatedAppointment.shop = response;

          // Get the shop's message tempaltes
          MessageTemplates
          .get(returnData.updatedAppointment.shop.message_templates)
          .then(function(response) {
            returnData.updatedAppointment.shop.messageTemplates = response;
            // Update the current appointment on the parent component
            vm.onAppointmentChange(
              {appointment: returnData.updatedAppointment}
            );
          });
        });
      }
    }, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name addCompletedphoto
   * @description Function to open the add completed photo modalInstance.
   */
  function addCompletedphoto() {
    let modalInstance = $uibModal.open({
      template: require('./completed-photo/completed-photo.template.html'),
      animation: true,
      controller: 'CompletedPhotoController as $ctrl',
      resolve: {
        project: function() {
          return vm.project;
        },
        appointment: function() {
          return vm.currentAppointment;
        }
      }
    });
    modalInstance.result.then(function(project) {
      vm.project = project;
      vm.onProjectChange({project});

      // Update appointment activity
      let conversationId;
      let appointmentId;
      $rootScope.$broadcast('merge-activity', conversationId,
      appointmentId, project.id);
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }
}

angular
  .module('inkfinder')
  .controller('ProjectController', ProjectController);



// WEBPACK FOOTER //
// ./components/projects/project/project.controller.js